export default {
  common: {
    success: '成功',
  },
  // 其他翻译内容
}
